import React from 'react';
import fieldConditionService from '../../services/field-condition-service';
import TextField from './field/text-field';
import NumberField from './field/number-field';
import DateField from './field/date-field';
import TitleField from './field/title-field';
import SubtitleField from './field/subtitle-field';
import ParagraphField from './field/paragraph-field';
import InitialValue from './field/initial-value/initial-value';
import Colors from './field/colors';
import FileField from './field/file-field';
import HiddenField from './field/hidden-field';
import CheckboxField from './field/checkbox-field';
import RadioField from './field/radio-field';
import DropdownField from './field/dropdown';
import FieldWidth from './field/field-width';
import FieldLabel from './field/field-label';
import FieldHelpText from './field/field-help-text';
import FieldMandatory from './field/field-mandatory';
import ConditionId from './field/condition-id';
import FieldType from './field/field-type';
import PhoneNumberField from './field/phone-number-field';
import PromotionalCode from './field/promotional-code';
import TextArea from './field/text-area';

class FormItem extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      conditions: props.conditions,
      model: props.model || {},
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    return prevState.conditions === nextProps.conditions ?
      null :
      {conditions: nextProps.conditions};
  }

  updateModel(newModel) {
    this.setState(
      { model: newModel },
      () => this.props.onChange(this.state.model)
    );
  }

  render() {
    const usedInCondition = fieldConditionService.usedInCondition(this.state.model.id, this.state.conditions);
    return <div className="modal" id={this.props.id} tabIndex="-1">
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title">Form item</h4>
            <button type="button"
                    className="btn-close"
                    data-bs-dismiss="modal" aria-label="Close">
            </button>
          </div>
          <div className="modal-body">
            <FieldType id={this.props.id}
                       usedInCondition={usedInCondition}
                       value={this.state.model.fieldType}
                       onChange={v => this.updateModel({...this.state.model, fieldType: v})}/>
            {this.state.model.fieldType === 'TEXT_FIELD' &&
              <TextField id={this.props.id}
                         conditions={this.state.conditions}
                         value={this.state.model}
                         onChange={newModel => this.updateModel({...this.state.model, ...newModel})}/>
            }
            {this.state.model.fieldType === 'TEXT_AREA' &&
            <TextArea id={this.props.id}
                      conditions={this.state.conditions}
                      value={this.state.model}
                      onChange={newModel => this.updateModel({...this.state.model, ...newModel})}/>
            }
            {this.state.model.fieldType === 'NUMBER' &&
              <NumberField id={this.props.id}
                           conditions={this.state.conditions}
                           model={this.state.model}
                           onChange={newModel => this.updateModel({...this.state.model, ...newModel})}/>
            }
            {this.state.model.fieldType === 'CHECKBOX' &&
            <CheckboxField id={this.props.id}
                           conditions={this.state.conditions}
                           model={this.state.model}
                           onChange={newModel => this.updateModel({...this.state.model, ...newModel})}/>
            }
            {this.state.model.fieldType === 'RADIO' &&
            <RadioField id={this.props.id}
                        conditions={this.state.conditions}
                        model={this.state.model}
                        onChange={newModel => this.updateModel({...this.state.model, ...newModel})}/>
            }
            {this.state.model.fieldType === 'DROPDOWN' &&
            <DropdownField id={this.props.id}
                           conditions={this.state.conditions}
                           model={this.state.model}
                           onChange={newModel => this.updateModel({...this.state.model, ...newModel})}/>
            }
            {this.state.model.fieldType === 'DATE' &&
            <DateField id={this.props.id}
                       conditions={this.state.conditions}
                       model={this.state.model}
                       onChange={newValue => this.updateModel({...this.state.model, ...newValue})}/>
            }
            {this.state.model.fieldType === 'PHONE_NUMBER' &&
            <PhoneNumberField id={this.props.id}
                              conditions={this.state.conditions}
                              value={this.state.model}
                              onChange={newValue => this.updateModel({...this.state.model, ...newValue})}/>
            }
            {this.state.model.fieldType === 'PROMO_CODE' &&
              <PromotionalCode id={this.props.id}
                               conditions={this.state.conditions}
                               value={this.state.model}
                               onChange={newValue => this.updateModel({...this.state.model, ...newValue})}/>
            }
            {this.state.model.fieldType === 'FILE' &&
            <FileField id={this.props.id}
                       conditions={this.state.conditions}
                       model={this.state.model}
                       onChange={v => this.updateModel({...this.state.model, ...v})}/>
            }
            {this.state.model.fieldType === 'HIDDEN' &&
            <HiddenField id={this.props.id} model={this.state.model} onChange={newValue => this.updateModel({...this.state.model, ...newValue})}/>
            }
            {this.state.model.fieldType === 'TITLE' &&
            <TitleField id={this.props.id}
                        conditions={this.state.conditions}
                        model={this.state.model}
                        onChange={newValue => this.updateModel({...this.state.model, ...newValue})}/>
            }
            {this.state.model.fieldType === 'SUBTITLE' &&
            <SubtitleField id={this.props.id}
                           conditions={this.state.conditions}
                           value={this.state.model}
                           onChange={newValue => this.updateModel({...this.state.model, ...newValue})}/>
            }
            {this.state.model.fieldType === 'PARAGRAPH' &&
            <ParagraphField id={this.props.id}
                            conditions={this.state.conditions}
                            model={this.state.model}
                            onChange={newValue => this.updateModel({...this.state.model, ...newValue})}/>
            }
            {(this.state.model.fieldType === 'EMAIL' || this.state.model.fieldType === 'COLOR') &&
            <FieldLabel value={this.state.model.label}
                        onChange={v => this.updateModel({...this.state.model, label: v})}/>
            }
            {this.state.model.fieldType === 'EMAIL' &&
            <div className="mb-3">
              <label htmlFor="placeholder" className="form-label">Placeholder</label>
              <input id="placeholder" name="placeholder"
                     type="text"
                     className="form-control"
                     value={this.state.model.placeholder || ''}
                     onChange={e => this.updateModel({...this.state.model, ...{placeholder: e.target.value}})}/>
              <div className="form-text">Short hint, will appear in the field before it is filled out.</div>
            </div>
            }
            {(this.state.model.fieldType === 'EMAIL' || this.state.model.fieldType === 'COLOR') &&
            <FieldHelpText value={this.state.model.helpText}
                           onChange={v => this.updateModel({...this.state.model, ...{helpText: v}})}/>
            }
            {this.state.model.fieldType === 'EMAIL' &&
            <InitialValue fieldType={this.state.model.fieldType}
                          value={this.state.model.initialValue || {}}
                          radioBoxPrefix={this.props.id}
                          onChange={newValue => this.updateModel({
                            ...this.state.model,
                            initialValue: newValue
                          })}/>
            }
            {(this.state.model.fieldType === 'EMAIL' || this.state.model.fieldType === 'COLOR') &&
            <FieldMandatory id={this.props.id}
                            value={this.state.model.mandatory}
                            onChange={v => this.updateModel({...this.state.model, ...{mandatory: v}})}
                            conditionallyDisplayed={!!this.state.model.conditionId}/>
            }
            {this.state.model.fieldType === 'COLOR' &&
            <div style={{marginTop: '25px'}}>
              <Colors value={this.state.model.colors}
                      onChange={value => this.updateModel({...this.state.model, colors: value})}/>
            </div>
            }
            {(this.state.model.fieldType === 'EMAIL' || this.state.model.fieldType === 'COLOR' ||
                this.state.model.fieldType === 'DIVIDER') &&
            <FieldWidth value={this.state.model.widthInPercent}
                        onChange={v => this.updateModel({...this.state.model, widthInPercent: v})}/>
            }
            {this.state.model.fieldType === 'DIVIDER' &&
            <div className="mb-3">
              <label htmlFor="marginTop" className="form-label">Top margin in pixels</label>
              <input id="marginTop" name="marginTop"
                     type="number" step="1"
                     className="form-control"
                     value={this.state.model.marginTop || ''}
                     onChange={e => this.updateModel({...this.state.model, marginTop: e.target.value})}/>
              <div className="form-text">Leave blank to use your theme defaults</div>
            </div>
            }
            {this.state.model.fieldType === 'DIVIDER' &&
            <div className="mb-3">
              <label htmlFor="marginBottom" className="form-label">Bottom margin in pixels</label>
              <input id="marginBottom" name="marginBottom"
                     type="number" step="1"
                     className="form-control"
                     value={this.state.model.marginBottom || ''}
                     onChange={e => this.updateModel({...this.state.model, marginBottom: e.target.value})}/>
              <div className="form-text">Leave blank to use your theme defaults</div>
            </div>
            }
            {this.state.model.fieldType === 'EMAIL' &&
            <div className="form-check mb-3">
              <input id={this.props.id + 'UseAsReplyTo'}
                     name={this.props.id + 'UseAsReplyTo'}
                     type="checkbox"
                     className="form-check-input"
                     checked={this.state.model.useAsReplyTo == null ? false : this.state.model.useAsReplyTo}
                     onChange={e => this.updateModel({...this.state.model, useAsReplyTo: e.target.checked})}/>
              <label className="form-check-label" htmlFor={this.props.id + 'UseAsReplyTo'}>
                Use as reply-to address
              </label>
              <div className="form-text">
                If checked, the form submission email sent to you has this email address as &quot;reply-to&quot;.<br/>
              </div>
            </div>
            }
            {(this.state.model.fieldType === 'EMAIL' || this.state.model.fieldType === 'COLOR' ||
                this.state.model.fieldType === 'DIVIDER') &&
            <ConditionId id={this.props.id}
                         conditions={this.state.conditions}
                         value={this.state.model.conditionId}
                         onChange={v => this.updateModel({...this.state.model, conditionId: v})}/>
            }
          </div>
          <div className="modal-footer">
            <div className="row justify-content-end">
              <div className="col-auto">
                <button type="button"
                        className="btn btn-primary px-5"
                        data-bs-dismiss="modal" aria-label="Close">
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
  }
}

export default FormItem;
